import { fetchCompanies } from "../utils/http/companies";
import { queryClient } from "../utils/http/queryClient";

export async function companiesLoader() {
  const companies = await queryClient.fetchQuery({
    queryKey: ["companies", "active", 1, 50], // Pre-fetch first page with active companies
    queryFn: ({ signal }) => fetchCompanies({ signal, status: "active", page: 1, size: 50 }),
    staleTime: 2000,
  });

  return companies;
}
